import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import useNotification from '../../../../hooks/useNotification';
import useAxios from '../../../../hooks/useAxios';
import {
  deleteEntranceSchedule,
} from '../../../../api/placeTest.api';
import Loader from '../../../Loader';
import ErrorResponse from '../../../ErrorResponse';
import { IEntranceSchedule } from '../../../../models/placeTest.model';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  getSchedules: () => void;
  record?: IEntranceSchedule;
}

const DeleteExamScheduleModal: FC<IProps> = ({
  visible,
  setVisible,
  getSchedules,
  record,
}) => {
  const { t } = useTranslation();
  const { warningNotification, successNotification } = useNotification();
  const { data: deleteRes, isLoading: deleteIsLoading, error: deleteError, execute: deleteExecute } = useAxios();

  const onDeleteSchedule = () => {
    if (!record?.platScheduleCode || !record) return;
    if (record?.applyCnt !== 0) return warningNotification(t('entrance.schedule.1'));
    
    deleteExecute(deleteEntranceSchedule(record?.platScheduleCode));
  }

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      getSchedules();
      successNotification(t('common.message.delete'));
      setVisible(false);
    }
  }, [deleteRes, deleteIsLoading]);

  return (
    <>
      {deleteIsLoading ? <Loader /> : null}
      <ErrorResponse error={deleteError} />
      <Modal
        title={t('entrance.schedule.2')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton key="submit"className='btn-basic pink' onClick={onDeleteSchedule}>
              {t('common.button.delete')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          {deleteIsLoading ? <Loader /> : null}
          <ErrorResponse error={deleteError} />
            {t('entrance.schedule.3')}
        </div>
      </Modal>
    </>
  );
};

export default DeleteExamScheduleModal;
